import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import {convertPipeToBrTag} from "../../utils";
import './styles.css';
import {IS_MOBILE} from "../../constants/environment";
import BodyControl from "../../components/body";

/**
 *  TabNavigation
 */
class TabNavigation extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    // links: PropTypes.array,
    links: PropTypes.arrayOf(PropTypes.shape({
      pageName: PropTypes.string,
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      href: PropTypes.string,
      external: PropTypes.bool,
      current: PropTypes.bool,
    })),
    bottom: PropTypes.bool,
    linkColor: PropTypes.string,
    linkToTabAnchor: PropTypes.bool,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    links: null,
    bottom: null,
    linkColor: null,
    linkToTabAnchor: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      subNavigationHeight: 0,
    }
  }
  
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      links,
      bottom,
      linkColor,
      linkToTabAnchor,
    } = this.props;
    
    let tab_anch_hash = (linkToTabAnchor && linkToTabAnchor === true) ? '#tab_anch': '';
    
    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <div
          className="TabNavigation"
          id={(() => {
            if (this.props.bottom === false) {
              return ('tab_anch')
            }
          })()}
          style={(0 < this.state.subNavigationHeight) ? {paddingTop: this.state.subNavigationHeight, marginTop: -this.state.subNavigationHeight} : null}
        >
          <div
            className={
              "TabNavigation__container" +
              ((this.props.linkColor && this.props.linkColor !== '') ? ' TabNavigation__container--' + this.props.linkColor: '') +
              ((this.props.bottom && this.props.bottom === true) ? ' TabNavigation__container--bottom': '')
            }
          >
            <ul
              className={"TabNavigation__list" + ((this.props.links.length > 0) ? ' TabNavigation__list--' + this.props.links.length: '')}>
              {this.props.links.map((link, index) => {
                let pcText, mbText;
                if (link.pcText && link.pcText !== '') {
                  pcText = link.pcText;
                }
                else {
                  if (link.mbText && link.mbText !== '') {
                    pcText = link.mbText;
                  }
                  else if (link.pageName && link.pageName !== '') {
                    pcText = link.pageName;
                  }
                  else {
                    pcText = '';
                  }
                }
                if (link.mbText && link.mbText !== '') {
                  mbText = link.mbText;
                }
                else {
                  if (link.pcText && link.pcText !== '') {
                    mbText = link.pcText;
                  }
                  else if (link.pageName && link.pageName !== '') {
                    mbText = link.pageName;
                  }
                  else {
                    mbText = '';
                  }
                }
                return (
                  <li
                    key={index}
                    ref={'item' + index}
                    className={"TabNavigation__list__item" + ((link.current === true) ? ' TabNavigation__list__item--current': '')}
                  >
                    <a
                      href={(link.href && link.href !== null) ? link.href + tab_anch_hash: null}
                      target={(link.external === true) ? '_blank': ''}
                      className="TabNavigation__list__item__link"
                    >
                      {(pcText && pcText !== '') ? <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(pcText)}}
                                                         className="TabNavigation__list__item__link__text--pc"/>: null}
                      {(mbText && mbText !== '') ? <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(mbText)}}
                                                         className="TabNavigation__list__item__link__text--mb"/>: null}
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </Wrapper>
    )
  }
  
  componentDidMount() {
    const height = BodyControl.getSubNavigationHeight();
    if (0 < height) {
      this.setState({
        subNavigationHeight: height
      })
    }
    //
    let hash = location.hash;
    if(hash && hash === '#tab_anch'){
      setTimeout(()=> {
        const element = document.getElementById('tab_anch');
        if (element) {
          const top = element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo(0, top - 1);
        }
      }, 200);
    }
  };
  
}

export default TabNavigation;



// WEBPACK FOOTER //
// ./src/containers/tab-navigation/index.jsx